function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 5,
  rx: 2.5,
  transform: "matrix(-0.852906 -0.522064 -0.522064 0.852906 38.0254 11.9766)",
  fill: "#FFB614"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 5,
  rx: 2.5,
  transform: "matrix(-1 0 0 1 32.7012 10)",
  fill: "#FFB614"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 38.0254,
  y: 13.6748,
  width: 22,
  height: 5,
  rx: 2.5,
  transform: "rotate(148.529 38.0254 13.6748)",
  fill: "#FFB614"
});

function SvgGoAway(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoAway);
export default __webpack_public_path__ + "static/media/goAway.74b7b96f.svg";
export { ForwardRef as ReactComponent };